"use client";

import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import ErrorBoundaryWrapper from "@portal/components/organisms/layouts/errorBoundaryWrapper";
import { Suspense } from "react";

export default function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <Suspense fallback={<PageSpinner />}>
      <ErrorBoundaryWrapper>{children}</ErrorBoundaryWrapper>
    </Suspense>
  );
}
